
export const FETCH_PICTURE_DATA = 'FETCH_PICTURE_DATA';
export const DELETE_PICTURE = 'DELETE_PICTURE';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_SITE_KEY = "SET_SITE_KEY";